import { render } from "./HomeProfileIcon.vue?vue&type=template&id=217ac195"
import script from "./HomeProfileIcon.vue?vue&type=script&lang=js"
export * from "./HomeProfileIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__